import React, { useState, useEffect } from "react";
import "./style.scss";
import Heading from "../../elements/heading";

import PropTypes from "prop-types";
import IconLink from "../../elements/icon-link";
import BodyText from "../../elements/body-text";

const ResetPasswordConfirmation = ({ headingType, headingBody, body, email, resendButton, emailNotExistMessage, maxRequestReachedMessage, sendLinkFailedMessage, sendResetPasswordLink }) => {
  const [headingText, setHeadingText] = useState(`${headingBody.value}<span class="type-h4">${email}</span>`);
  const [serverError, setServerError] = useState(null);
  const submitResendResetPassword = async (evt, data) => {
    if (evt) {
      evt.stopPropagation();
      evt.preventDefault();
    }
    try {
      await sendResetPasswordLink(evt, data);
    } catch (res) {
      switch (res.code) {
        // case "EMAIL_EXCEPTION_001":
        //   setEmailIsValid(false);
        //   break;
        case "USER_CUSTOMER_0003":
          setServerError(emailNotExistMessage.value);
          break;
        case "USER_CUSTOMER_0013":
          setServerError(maxRequestReachedMessage.value);
          break;
        default:
          setServerError(sendLinkFailedMessage.value);
          break;
      }
    }
  };
  const onSubmit = evt => {
    const formData = { email };
    submitResendResetPassword(evt, formData);
  };
  useEffect(() => {
    setHeadingText(`${headingBody.value}<span class="type-h4">${email}</span>`);
  }, [email, headingBody.value]);
  return (
    <div className="reset-password-confirmation">
      {headingType && <Heading type={headingType} className="title show-on-scroll" html={{ value: headingText }} typographyClass="type-h3" />}

      {body && (
        <div
          className={"body-text"}
          dangerouslySetInnerHTML={{
            __html: body.value
          }}
        />
      )}
      {serverError && <BodyText className="failed-message" html={serverError} />}
      <div className="button-container">{resendButton && <IconLink {...{ ...resendButton, callback: evt => onSubmit(evt) }} />}</div>
    </div>
  );
};

ResetPasswordConfirmation.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.object,
  email: PropTypes.string,
  resendButton: PropTypes.object,
  submitResendForgotPassword: PropTypes.func
};

ResetPasswordConfirmation.defaultProps = {
  submitResendResetPassword: () => {}
};

export default ResetPasswordConfirmation;
